/**
 * Pricing/CTA card under the login glass. Stripe Payment Link CTA is
 * driven by VITE_STRIPE_PAYMENT_LINK; falls back to /pricing when unset
 * so the link is never broken.
 */

import React from 'react';

const PricingStrip: React.FC = () => {
  const stripeLink = import.meta.env.VITE_STRIPE_PAYMENT_LINK;
  const trialDays = import.meta.env.VITE_STRIPE_TRIAL_DAYS || '7';
  const promo = import.meta.env.VITE_PROMO_CODE || 'TRIAL';

  // Treat the placeholder we ship in .env.example as "unset".
  const validStripe = stripeLink && !/REPLACE_ME/i.test(stripeLink);
  const ctaHref = validStripe ? stripeLink : '/pricing';

  return (
    <aside className="login-pricing" aria-label="Trial offer">
      <div className="ttl">UNLOCK THE TERMINAL</div>
      <p style={{ fontSize: 11, color: 'var(--text-3)', lineHeight: 1.6, marginBottom: 16 }}>
        GEX + VEX heatmaps. 5 indices. WebSocket live. Always streaming.
      </p>
      <a
        className="cta"
        href={ctaHref}
        target={validStripe ? '_blank' : undefined}
        rel={validStripe ? 'noopener noreferrer' : undefined}
      >
        Start your {trialDays}-day free trial
      </a>
      <p style={{ fontSize: 10, color: 'var(--text-4)', marginTop: 8 }}>
        then $49/mo — cancel anytime before day {trialDays}.
      </p>
      <p style={{ fontSize: 10, color: 'var(--text-3)', marginTop: 12 }}>
        Use code <code style={{ color: 'var(--cyan)', fontFamily: 'var(--font-mono)' }}>{promo}</code> for 50% off your first month.
      </p>
    </aside>
  );
};

export default PricingStrip;
